import { AfterViewInit, Directive, Optional } from '@angular/core';
import { DxSelectBoxComponent, DxTagBoxComponent, DxTreeViewComponent } from 'devextreme-angular';

/**
 * Makes every dx-select-box / dx-tag-box / dx-tree-view searchable by default.
 *
 * DevExtreme dropdowns ship with `searchEnabled` off. Rather than setting it on every
 * instance (and every instance added later), this directive applies it automatically
 * to any matching element that doesn't already configure `searchEnabled` itself.
 *
 * The `:not([searchEnabled])` selector excludes elements that already bind the input
 * (e.g. `[searchEnabled]="false"`), so explicit opt-outs are respected.
 *
 * Usage: add `SearchableDropdownDirective` to a standalone component's `imports` array;
 * it then applies to every matching element in that component's template, including
 * ones added later, with no further per-instance wiring.
 */
@Directive({
  selector: 'dx-select-box:not([searchEnabled]), dx-tag-box:not([searchEnabled]), dx-tree-view:not([searchEnabled])',
  standalone: true,
})
export class SearchableDropdownDirective implements AfterViewInit {
  constructor(
    @Optional() private selectBox: DxSelectBoxComponent,
    @Optional() private tagBox: DxTagBoxComponent,
    @Optional() private treeView: DxTreeViewComponent,
  ) {}

  ngAfterViewInit(): void {
    const widget = this.selectBox ?? this.tagBox ?? this.treeView;
    if (widget) {
      widget.searchEnabled = true;
    }
  }
}
